import { pipe } from 'fp-ts/lib/function';
import { fromNullable } from 'fp-ts/lib/Option';
import { getPlan, planNameToType, PLAN_STARTER } from '../services/auth.service';
/**
 * @returns * the **team** owner, if the project is a team project;
 *          * the **project** owner otherwise
 */
export function getProjectOwner(project) {
    return project.team ? project.team.owner : project.owner;
}
/**
 * Falls back to the `starter` plan if failed to calculate the actual plan.
 */
export function getOwnerPlan(owner) {
    var _a;
    return fromNullable((_a = owner === null || owner === void 0 ? void 0 : owner.billing) === null || _a === void 0 ? void 0 : _a.plan_name).chain(planNameToType).map(getPlan).getOrElse(PLAN_STARTER);
}
/**
 * Checks whether an integration can be configured for the provided `project` by its owner.
 */
export var canConfigureIntegration = pipe(getProjectOwner, getOwnerPlan, function (plan) { return plan.features.useExport; });
/**
 * Checks whether the provided `userId` can configure integrations for given `project`. This is `true` if the user is the owner
 * and their plan allows export.
 */
export var canUserConfigureIntegration = function (project, userId) { var _a; return canConfigureIntegration(project) && ((_a = getProjectOwner(project)) === null || _a === void 0 ? void 0 : _a.id) === userId; };
/**
 * Checks whether the provided `userId` can use integrations of the given `project`. According to the current rules, any user
 * who can access the project can use its integrations.
 *
 * **Note:** this function assumes that the user can access the project, so this is not checked.
 */
export var canMemberUseIntegration = function (_project, _userId) { return true; };
//# sourceMappingURL=permissions.model.js.map